/** Foto profil akun, atau huruf pertama nama project kalau tidak ada. */
export function Avatar({ url, name, size = 'md' }: { url: string | null; name: string; size?: 'md' | 'lg' }) {
  const cls = size === 'lg' ? 'size-12 text-lg' : 'size-10 text-sm'
  if (url) return <img src={url} alt="" className={`${cls} shrink-0 rounded-full object-cover`} />
  return (
    <span className={`${cls} flex shrink-0 items-center justify-center rounded-full bg-muted font-semibold uppercase text-muted-foreground`}>
      {name.trim().charAt(0) || '?'}
    </span>
  )
}
